// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router/router.js'
import './assets/main.css'
import { createPinia } from 'pinia';


const app = createApp(App);
app.use(createPinia());

app.use(router).mount('#app');
